// import $ from 'jquery';

// import script accordingly
// import "./themes/header/_header";
// import "./themes/header/_footer";

import './themes/elementor-widget/_elementor-widget';
import './themes/gallery/_gallery';
import './themes/shortcode/_shortcode';
